"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityMultiValueList = exports.EntityMultiValueListDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_multi_value_1 = require("./entity-multi-value");
var cell_header_1 = require("../elements/cell-header");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var lodash_1 = require("lodash");
var entity_link_1 = require("./entity-link");
var tag_1 = require("../elements/tag");
var sprintf_js_1 = require("sprintf-js");
var use_lang_1 = require("../../hooks/use-lang");
exports.EntityMultiValueListDefaultProps = {
  items: [],
  useLinks: false,
  background: "app-chrome"
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValuesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "], ["\n    margin-top: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "])), theme_1.theme.UNIT(2))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TagStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-radius: 50px;\n    font-size: ", ";\n    border-color: ", ";\n    align-items: center;\n    display: flex;\n    box-sizing: border-box;\n    min-height: 36px;\n  "], ["\n    border-radius: 50px;\n    font-size: ", ";\n    border-color: ", ";\n    align-items: center;\n    display: flex;\n    box-sizing: border-box;\n    min-height: 36px;\n  "])), theme_1.theme.FONT_SIZE(12), theme_1.theme.COLOR('line-sidebar'))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "], ["\n    margin-bottom: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2), function (props) {
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme_1.theme.COLOR(props._background));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: (0, styled_components_1.default)(cell_header_1.CellHeader)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Values: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ValuesStyles),
  Link: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_multi_value_1.EntityMultiValue)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Tag: (0, styled_components_1.default)(tag_1.Tag)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TagStyles)
};
var EntityMultiValueList = function (props) {
  var className = props.className,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    useLinks = props.useLinks,
    headerLabel = props.headerLabel,
    background = props.background,
    maxItems = props.maxItems,
    valueProps = __rest(props, ["className", "items", "useLinks", "headerLabel", "background", "maxItems"]);
  var defn = items && items.length > 0 && (0, use_entity_definition_1.useEntityDefinition)(items[0]);
  var itemsToShow = !!maxItems ? items.slice(0, maxItems) : items;
  var extras = items.length - itemsToShow.length;
  var t = (0, use_lang_1.useLang)();
  if (!items.length) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Header, null, (0, lodash_1.trim)(headerLabel || defn && defn.pluralLabel, ":"), ":"), react_1.default.createElement(My.Values, null, itemsToShow.map(function (item) {
    var value = react_1.default.createElement(My.Value, __assign({
      _background: background,
      key: item.id,
      entity: item
    }, valueProps));
    return useLinks ? react_1.default.createElement(My.Link, {
      entity: item
    }, value) : value;
  }), !!extras && react_1.default.createElement(My.Tag, {
    isListItem: true,
    isExtra: true
  }, (0, sprintf_js_1.sprintf)(t("+ %d more"), extras))));
};
exports.EntityMultiValueList = EntityMultiValueList;
exports.EntityMultiValueList.defaultProps = exports.EntityMultiValueListDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;